import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material';
import {WithdrawalCommandsService} from '../services/withdrawal-commands.service';
import {environment} from '../../environments/environment';

@Component({
  styleUrls: ['./withdrawal-details.component.scss'],
  templateUrl: './withdrawal-details.component.html'
})
export class WithdrawalDetailsComponent implements OnInit {
  private withdrawalId: number;
  public dataSource: MatTableDataSource<Details>;
  public damagesDataSource = new MatTableDataSource<Damage>();
  public damagesDisplayedColumns: string[] = ['damage_id', 'damage_name'];
  public displayedColumns: string[] = ['serial_number', 'comments'];
  public canShowInfo: boolean;
  public showExtraInfo: boolean;
  public loadingImages: boolean;
  public imageFileSource: string[];
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  public selectedRow: any;
  public title: string;
  public responseDetails: any;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private withdrawalCommandsService: WithdrawalCommandsService) {
  }

  public async ngOnInit(): Promise<any> {
    this.canShowInfo = false;
    this.showExtraInfo = false;
    this.loadingImages = false;
    this.imageFileSource = [];
    this.activatedRoute.params.subscribe((params) => {
      this.withdrawalId = params.id;
    });

    this.responseDetails = await this.withdrawalCommandsService.fetchWithdrawalCommand(this.withdrawalId);

    this.title = 'Πληροφορίες αίτησης απόσυρσης';
    this.dataSource = new MatTableDataSource<Details>();
    this.dataSource.data = this.responseDetails.details;


    this.canShowInfo = true;
    this.showBasicInfo = false;
    await this.initUser();

  }

  private async initUser() {
    this.user = await this.authService.getUser();
    await this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [
        {
          title: 'Αριθμός Εντολής',
          value: this.responseDetails.id
        }
      ],
      title: this.title
    };
    await this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  async getRow(row: any) {
    this.selectedRow = row;
    this.loadingImages = true;
    this.damagesDataSource.data = row.damages;
    this.showExtraInfo = true;

    this.imageFileSource = [];
    for (const file of row.files) {
      const imageFile = `${environment.apiUrl}files?name=${file.file_name}&model=withdrawals`;
      this.imageFileSource.push(imageFile);
    }
    this.loadingImages = false;
  }
}
